import { useEffect } from "react";
import { matchesShortcut } from "@/components/ui/os-layout/osShortcuts";

interface UseSearchKeyboardShortcutsOptions {
  isSearchOpen: boolean;
  openSearch: () => void;
  closeSearch: () => void;
}

/**
 * Classic-layout keyboard shortcuts for global search.
 * aniOS mode uses useOsShortcuts instead.
 */
export function useSearchKeyboardShortcuts({
  isSearchOpen,
  openSearch,
  closeSearch,
}: UseSearchKeyboardShortcutsOptions): void {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (matchesShortcut(event, "TOGGLE_GLOBAL_SEARCH")) {
        event.preventDefault();
        if (isSearchOpen) {
          closeSearch();
        } else {
          openSearch();
        }
        return;
      }

      if (
        matchesShortcut(event, "CLOSE_ACTIVE_WINDOW") &&
        isSearchOpen
      ) {
        event.preventDefault();
        closeSearch();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [closeSearch, isSearchOpen, openSearch]);
}
